<template>
  <v-app light v-cloak :dark="false">
      <core-view></core-view>
  </v-app>
</template>

<script>
export default {
    computed: {
  },
}
</script>
